"use client";

import React from "react";

/**
 * Image - Responsive image with optional thumbnail/rounded styles.
 *
 * @param {boolean} fluid - max-width: 100%, height: auto
 * @param {boolean} rounded - border-radius
 * @param {boolean} roundedCircle - fully rounded
 * @param {boolean} thumbnail - bordered thumbnail style
 */
export function Image({
  fluid = false,
  rounded = false,
  roundedCircle = false,
  thumbnail = false,
  className = "",
  ...props
}) {
  const classes = [
    (fluid || thumbnail) && "max-w-full h-auto",
    rounded && "rounded",
    roundedCircle && "rounded-full",
    thumbnail && "p-1 bg-white border border-lightGrey3 rounded",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return <img className={classes.trim()} {...props} />;
}
